/**
 * The funnel conversions the browser reports to the ad pixels. The names are the
 * backend's internal events: it sends the same conversion server-side with
 * `event_id = "<event>-<brandId>"`, and the platforms drop the duplicate when the
 * browser's copy carries the same id.
 */
export type AdConversionEvent = "landing_url_submitted" | "campaign_published";

export const conversionEventId = (
  event: AdConversionEvent,
  brandId: string,
): string => `${event}-${brandId}`;

const META_EVENTS: Record<AdConversionEvent, string> = {
  landing_url_submitted: "ViewContent",
  campaign_published: "Lead",
};

const TIKTOK_EVENTS: Record<AdConversionEvent, string> = {
  landing_url_submitted: "ClickButton",
  campaign_published: "CompleteRegistration",
};

/** The Meta standard event a conversion is reported as. */
export const metaEventName = (event: AdConversionEvent): string =>
  META_EVENTS[event];

/** The TikTok standard event a conversion is reported as. */
export const tiktokEventName = (event: AdConversionEvent): string =>
  TIKTOK_EVENTS[event];
